import { Navigate } from '@tanstack/react-router'
import { useCampaigns } from '../lib/campaign.tsx'
import { isPlatformAdmin } from '../lib/roles.ts'
import { useSession } from '../lib/session.ts'

/**
 * Where "/" lands (2026-09-30): SuperAdmin and Org Admins on Today (owner,
 * 2026-10-01 — the business first), anyone holding several campaigns on My campaigns, everyone else
 * straight into their one campaign.
 */
export function Home() {
  const { data: session } = useSession()
  const { data, isPending } = useCampaigns()

  if (isPlatformAdmin(session)) return <Navigate to="/platform/today" replace />
  if (isPending) return <p className="text-sm text-ink-muted">Loading…</p>

  const campaigns = data?.campaigns ?? []
  if (campaigns.length > 1) return <Navigate to="/campaigns" replace />
  if (campaigns.length === 1) return <Navigate to="/overview" replace />

  return (
    <div>
      <h1 className="text-xl font-semibold tracking-tight">No campaigns yet</h1>
      <p className="mt-2 max-w-prose text-sm text-ink-muted">
        Your account is not on any campaign that is open. Ask whoever invited you to add you to
        one, or to check that the campaign's paperwork has been recorded.
      </p>
    </div>
  )
}
